// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes swing {
  0% {
    transform: rotate(0);
  }
  25% {
    transform: rotate(15deg);
  }
  50% {
    transform: rotate(-15deg);
  }
  75% {
    transform: rotate(10deg);
  }
  100% {
    transform: rotate(0);
  }
}

.holiday-button:hover .button-icon {
  animation: swing 0.7s ease-in-out;
}

[data-theme="special"] .theme-button:hover svg path {
  fill: #324c33;
}

[data-theme="special"] .holiday-button {
  background: linear-gradient(#670a0a, #420707);
}

[data-theme="special"] .holiday-button:hover {
  border-color: var(--border-color) !important;
}

[data-theme="special"] .website-button svg .path-2 {
  fill: #bc9b3d;
}

[data-theme="special"] .website-button svg .path-3 {
  fill: #324c33;
}

[data-theme="special"] .website-button:hover svg .path-2 {
  fill: url(#b);
}

[data-theme="special"] .website-button:hover svg .path-3 {
  fill: url(#c);
}

[data-theme="special"] .bento-button:hover svg .path-0 {
  fill: #dbdbdb;
}

[data-theme="special"] .bento-button:hover svg .path-1 {
  fill: #ff8686;
}

[data-theme="special"] .bento-button:hover svg .path-2 {
  fill: #5aff88;
}

[data-theme="special"] .bento-button:hover svg .path-3 {
  fill: #768cff;
}

[data-theme="special"] .bento-button:hover svg .path-fill {
  fill: #ffffff;
}

[data-theme="special"] .bento-button svg .path-0 {
  fill: #817839;
}

[data-theme="special"] .bento-button svg .path-1 {
  fill: #324c33;
}

[data-theme="special"] .bento-button svg .path-2 {
  fill: #324c33;
}

[data-theme="special"] .bento-button svg .path-3 {
  fill: #324c33;
}

[data-theme="special"] .bento-button svg .path-fill {
  fill: #bc9b3d;
}

[data-theme="special"] .email-button .button-icon svg path {
  fill: #bc9b3d !important;
}

[data-theme="special"] .email-button:hover .button-icon svg path {
  fill: var(--fill-color) !important;
}

[data-theme="special"] .button:hover .button-label {
  color: #5e0043;
}

[data-theme="special"] .dashboard-button svg .path-1 {
  fill: #324c33;
}

[data-theme="special"] .dashboard-button:hover svg .path-1 {
  fill: inherit;
}

[data-theme="special"] .dashboard-button:hover svg .path-2 {
  fill: inherit;
}

[data-theme="special"] .dashboard-button:hover svg .path-3 {
  fill: inherit;
}

[data-theme="special"] .dashboard-button svg .path-2 {
  fill: #817839;
}

[data-theme="special"] .dashboard-button svg .path-3 {
  fill: #bc9b3d;
}

[data-theme="special"] .dashboard-button:hover svg .path-1 {
  fill: #45059d;
}

[data-theme="special"] .dashboard-button:hover svg .path-2 {
  fill: url(#paint0_linear_144_56);
}

[data-theme="special"] .dashboard-button:hover svg .path-3 {
  fill: url(#paint1_linear_144_56);
}

[data-theme="special"] .gumroad-button:hover svg .path-1 {
  fill: #000000;
}

[data-theme="special"] .gumroad-button:hover svg .path-2 {
  fill: #ff90e8;
  stroke: #000000;
}

[data-theme="special"] .gumroad-button:hover svg .path-3 {
  fill: #000000;
}

[data-theme="special"] .gumroad-button svg .path-1 {
  fill: #324c33;
}

[data-theme="special"] .gumroad-button svg .path-2 {
  fill: #bc9b3d;
  stroke: #324c33;
}

[data-theme="special"] .gumroad-button svg .path-3 {
  fill: #324c33;
}

[data-theme="special"] .twitter-button:hover svg rect {
  fill: var(--fill-color);
}
[data-theme="special"] .linkedin-button svg rect {
  fill: #bc9b3d;
}

[data-theme="special"] .linkedin-button svg path {
  fill: #324c33;
}

[data-theme="special"] .linkedin-button:hover svg rect {
  fill: #0085ff;
}

[data-theme="special"] .linkedin-button:hover svg path {
  fill: #ffffff;
}

[data-theme="special"] .twitter-button svg rect {
  fill: #bc9b3d;
}

[data-theme="special"] .twitter-button svg path {
  fill: #324c33;
}

[data-theme="special"] .twitter-button:hover svg rect {
  fill: var(--fill-color);
}

[data-theme="special"] .twitter-button:hover svg path {
  fill: #ffffff;
}

[data-theme="special"] .bluesky-button svg path {
  fill: #bc9b3d;
}

[data-theme="special"] .bluesky-button:hover svg path {
  fill: #0085ff;
}

[data-theme="special"] .github-button svg path {
  fill: #bc9b3d;
}

[data-theme="special"] .github-button:hover svg path {
  fill: var(--fill-color);
}

[data-theme="special"] .dribbble-button:hover svg {
  fill: #ffabe7;
}

[data-theme="special"] .dribbble-button svg path {
  stroke: #324c33;
}

[data-theme="special"] .dribbble-button:hover svg path {
  stroke: #5e0043;
}

[data-theme="special"] .dribbble-button svg {
  fill: #bc9b3d;
}

[data-theme="special"] .card {
  box-shadow:
    0 0 15px 0px rgba(255, 246, 157, 0.8),
    0 0 10px 0px rgba(229, 204, 107, 0.6),
    0 0 15px 15px rgba(205, 164, 62, 0.4);
}

[data-theme="special"] .tooltip,
[data-theme="special"] .theme-button:hover,
[data-theme="special"] .website-button:hover,
[data-theme="special"] .bento-button:hover,
[data-theme="special"] .email-button:hover,
[data-theme="special"] .dashboard-button:hover,
[data-theme="special"] .gumroad-button:hover,
[data-theme="special"] .linkedin-button:hover,
[data-theme="special"] .twitter-button:hover,
[data-theme="special"] .bluesky-button:hover,
[data-theme="special"] .github-button:hover,
[data-theme="special"] .layers-button:hover,
[data-theme="special"] .dribbble-button:hover,
[data-theme="special"] .codepen-button:hover {
  background: linear-gradient(
    315deg,
    rgb(205, 164, 60) 0%,
    rgb(255, 247, 158) 100%
  );
}

[data-theme="special"] .tooltip,
[data-theme="special"] .website-button:hover .button-label,
[data-theme="special"] .bento-button:hover .button-label,
[data-theme="special"] .dashboard-button:hover .button-label,
[data-theme="special"] .linkedin-button:hover .button-label,
[data-theme="special"] .twitter-button:hover .button-label,
[data-theme="special"] .bluesky-button:hover .button-label,
[data-theme="special"] .github-button:hover .button-label,
[data-theme="special"] .codepen-button:hover .button-label {
  color: var(--special-text-theme-color) !important;
}

[data-theme="special"] .animated-line {
  background: repeating-linear-gradient(
    -45deg,
    rgb(242, 226, 163),
    rgb(153, 134, 91) 10px,
    rgb(103, 10, 10) 10px,
    rgb(57, 5, 5) 20px
  );
}

[data-theme="special"] .badge.circle {
  background-color: rgba(153, 134, 91, 50%);
}

[data-theme="special"] .section-description {
  color: var(--text-light-color);
}

[data-theme="special"] .background-manager {
  opacity: 0.04;
}

[data-theme="dark"] .holiday-button:hover svg .path-1,
[data-theme="dark"] .holiday-button:hover svg .path-2 {
  fill: #d7d5ff;
}

[data-theme="special"] .codepen-button .button-icon svg path {
  fill: #bc9b3d;
}

[data-theme="special"] .codepen-button:hover .button-icon svg path {
  fill: var(--fill-color);
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/special-theme.css"],"names":[],"mappings":"AAAA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;;;yCAGuC;AACzC;;AAEA;;;;;;;;;;;;;;EAcE;;;;GAIC;AACH;;AAEA;;;;;;;;;EASE,iDAAiD;AACnD;;AAEA;EACE;;;;;;GAMC;AACH;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":["@keyframes swing {\n  0% {\n    transform: rotate(0);\n  }\n  25% {\n    transform: rotate(15deg);\n  }\n  50% {\n    transform: rotate(-15deg);\n  }\n  75% {\n    transform: rotate(10deg);\n  }\n  100% {\n    transform: rotate(0);\n  }\n}\n\n.holiday-button:hover .button-icon {\n  animation: swing 0.7s ease-in-out;\n}\n\n[data-theme=\"special\"] .theme-button:hover svg path {\n  fill: #324c33;\n}\n\n[data-theme=\"special\"] .holiday-button {\n  background: linear-gradient(#670a0a, #420707);\n}\n\n[data-theme=\"special\"] .holiday-button:hover {\n  border-color: var(--border-color) !important;\n}\n\n[data-theme=\"special\"] .website-button svg .path-2 {\n  fill: #bc9b3d;\n}\n\n[data-theme=\"special\"] .website-button svg .path-3 {\n  fill: #324c33;\n}\n\n[data-theme=\"special\"] .website-button:hover svg .path-2 {\n  fill: url(#b);\n}\n\n[data-theme=\"special\"] .website-button:hover svg .path-3 {\n  fill: url(#c);\n}\n\n[data-theme=\"special\"] .bento-button:hover svg .path-0 {\n  fill: #dbdbdb;\n}\n\n[data-theme=\"special\"] .bento-button:hover svg .path-1 {\n  fill: #ff8686;\n}\n\n[data-theme=\"special\"] .bento-button:hover svg .path-2 {\n  fill: #5aff88;\n}\n\n[data-theme=\"special\"] .bento-button:hover svg .path-3 {\n  fill: #768cff;\n}\n\n[data-theme=\"special\"] .bento-button:hover svg .path-fill {\n  fill: #ffffff;\n}\n\n[data-theme=\"special\"] .bento-button svg .path-0 {\n  fill: #817839;\n}\n\n[data-theme=\"special\"] .bento-button svg .path-1 {\n  fill: #324c33;\n}\n\n[data-theme=\"special\"] .bento-button svg .path-2 {\n  fill: #324c33;\n}\n\n[data-theme=\"special\"] .bento-button svg .path-3 {\n  fill: #324c33;\n}\n\n[data-theme=\"special\"] .bento-button svg .path-fill {\n  fill: #bc9b3d;\n}\n\n[data-theme=\"special\"] .email-button .button-icon svg path {\n  fill: #bc9b3d !important;\n}\n\n[data-theme=\"special\"] .email-button:hover .button-icon svg path {\n  fill: var(--fill-color) !important;\n}\n\n[data-theme=\"special\"] .button:hover .button-label {\n  color: #5e0043;\n}\n\n[data-theme=\"special\"] .dashboard-button svg .path-1 {\n  fill: #324c33;\n}\n\n[data-theme=\"special\"] .dashboard-button:hover svg .path-1 {\n  fill: inherit;\n}\n\n[data-theme=\"special\"] .dashboard-button:hover svg .path-2 {\n  fill: inherit;\n}\n\n[data-theme=\"special\"] .dashboard-button:hover svg .path-3 {\n  fill: inherit;\n}\n\n[data-theme=\"special\"] .dashboard-button svg .path-2 {\n  fill: #817839;\n}\n\n[data-theme=\"special\"] .dashboard-button svg .path-3 {\n  fill: #bc9b3d;\n}\n\n[data-theme=\"special\"] .dashboard-button:hover svg .path-1 {\n  fill: #45059d;\n}\n\n[data-theme=\"special\"] .dashboard-button:hover svg .path-2 {\n  fill: url(#paint0_linear_144_56);\n}\n\n[data-theme=\"special\"] .dashboard-button:hover svg .path-3 {\n  fill: url(#paint1_linear_144_56);\n}\n\n[data-theme=\"special\"] .gumroad-button:hover svg .path-1 {\n  fill: #000000;\n}\n\n[data-theme=\"special\"] .gumroad-button:hover svg .path-2 {\n  fill: #ff90e8;\n  stroke: #000000;\n}\n\n[data-theme=\"special\"] .gumroad-button:hover svg .path-3 {\n  fill: #000000;\n}\n\n[data-theme=\"special\"] .gumroad-button svg .path-1 {\n  fill: #324c33;\n}\n\n[data-theme=\"special\"] .gumroad-button svg .path-2 {\n  fill: #bc9b3d;\n  stroke: #324c33;\n}\n\n[data-theme=\"special\"] .gumroad-button svg .path-3 {\n  fill: #324c33;\n}\n\n[data-theme=\"special\"] .twitter-button:hover svg rect {\n  fill: var(--fill-color);\n}\n[data-theme=\"special\"] .linkedin-button svg rect {\n  fill: #bc9b3d;\n}\n\n[data-theme=\"special\"] .linkedin-button svg path {\n  fill: #324c33;\n}\n\n[data-theme=\"special\"] .linkedin-button:hover svg rect {\n  fill: #0085ff;\n}\n\n[data-theme=\"special\"] .linkedin-button:hover svg path {\n  fill: #ffffff;\n}\n\n[data-theme=\"special\"] .twitter-button svg rect {\n  fill: #bc9b3d;\n}\n\n[data-theme=\"special\"] .twitter-button svg path {\n  fill: #324c33;\n}\n\n[data-theme=\"special\"] .twitter-button:hover svg rect {\n  fill: var(--fill-color);\n}\n\n[data-theme=\"special\"] .twitter-button:hover svg path {\n  fill: #ffffff;\n}\n\n[data-theme=\"special\"] .bluesky-button svg path {\n  fill: #bc9b3d;\n}\n\n[data-theme=\"special\"] .bluesky-button:hover svg path {\n  fill: #0085ff;\n}\n\n[data-theme=\"special\"] .github-button svg path {\n  fill: #bc9b3d;\n}\n\n[data-theme=\"special\"] .github-button:hover svg path {\n  fill: var(--fill-color);\n}\n\n[data-theme=\"special\"] .dribbble-button:hover svg {\n  fill: #ffabe7;\n}\n\n[data-theme=\"special\"] .dribbble-button svg path {\n  stroke: #324c33;\n}\n\n[data-theme=\"special\"] .dribbble-button:hover svg path {\n  stroke: #5e0043;\n}\n\n[data-theme=\"special\"] .dribbble-button svg {\n  fill: #bc9b3d;\n}\n\n[data-theme=\"special\"] .card {\n  box-shadow:\n    0 0 15px 0px rgba(255, 246, 157, 0.8),\n    0 0 10px 0px rgba(229, 204, 107, 0.6),\n    0 0 15px 15px rgba(205, 164, 62, 0.4);\n}\n\n[data-theme=\"special\"] .tooltip,\n[data-theme=\"special\"] .theme-button:hover,\n[data-theme=\"special\"] .website-button:hover,\n[data-theme=\"special\"] .bento-button:hover,\n[data-theme=\"special\"] .email-button:hover,\n[data-theme=\"special\"] .dashboard-button:hover,\n[data-theme=\"special\"] .gumroad-button:hover,\n[data-theme=\"special\"] .linkedin-button:hover,\n[data-theme=\"special\"] .twitter-button:hover,\n[data-theme=\"special\"] .bluesky-button:hover,\n[data-theme=\"special\"] .github-button:hover,\n[data-theme=\"special\"] .layers-button:hover,\n[data-theme=\"special\"] .dribbble-button:hover,\n[data-theme=\"special\"] .codepen-button:hover {\n  background: linear-gradient(\n    315deg,\n    rgb(205, 164, 60) 0%,\n    rgb(255, 247, 158) 100%\n  );\n}\n\n[data-theme=\"special\"] .tooltip,\n[data-theme=\"special\"] .website-button:hover .button-label,\n[data-theme=\"special\"] .bento-button:hover .button-label,\n[data-theme=\"special\"] .dashboard-button:hover .button-label,\n[data-theme=\"special\"] .linkedin-button:hover .button-label,\n[data-theme=\"special\"] .twitter-button:hover .button-label,\n[data-theme=\"special\"] .bluesky-button:hover .button-label,\n[data-theme=\"special\"] .github-button:hover .button-label,\n[data-theme=\"special\"] .codepen-button:hover .button-label {\n  color: var(--special-text-theme-color) !important;\n}\n\n[data-theme=\"special\"] .animated-line {\n  background: repeating-linear-gradient(\n    -45deg,\n    rgb(242, 226, 163),\n    rgb(153, 134, 91) 10px,\n    rgb(103, 10, 10) 10px,\n    rgb(57, 5, 5) 20px\n  );\n}\n\n[data-theme=\"special\"] .badge.circle {\n  background-color: rgba(153, 134, 91, 50%);\n}\n\n[data-theme=\"special\"] .section-description {\n  color: var(--text-light-color);\n}\n\n[data-theme=\"special\"] .background-manager {\n  opacity: 0.04;\n}\n\n[data-theme=\"dark\"] .holiday-button:hover svg .path-1,\n[data-theme=\"dark\"] .holiday-button:hover svg .path-2 {\n  fill: #d7d5ff;\n}\n\n[data-theme=\"special\"] .codepen-button .button-icon svg path {\n  fill: #bc9b3d;\n}\n\n[data-theme=\"special\"] .codepen-button:hover .button-icon svg path {\n  fill: var(--fill-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
